(() => {
  if (window.jbClubCarrito) return;
  window.jbClubCarrito = true;

  const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let cola = Promise.resolve();

  const guardar = (atributos) => {
    cola = cola
      .then(() =>
        fetch(raiz + 'cart/update.js', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: atributos }),
        })
      )
      .catch(() => {});
    return cola;
  };

  const sincronizar = (atributo, marcada) => {
    document.querySelectorAll('[data-jb-club-attr]').forEach((casilla) => {
      if (casilla.dataset.jbClubAttr === atributo) casilla.checked = marcada;
    });
  };

  document.addEventListener('change', (evento) => {
    const casilla = evento.target.closest && evento.target.closest('[data-jb-club-attr]');
    if (!casilla) return;
    const atributo = casilla.dataset.jbClubAttr;
    sincronizar(atributo, casilla.checked);
    guardar({ [atributo]: casilla.checked ? casilla.dataset.si : casilla.dataset.no });
  });

  const anotarVersion = (bloque) => {
    const version = bloque.dataset.version;
    if (!version || version === bloque.dataset.versionActual) return;
    document.querySelectorAll('[data-jb-club]').forEach((b) => (b.dataset.versionActual = version));
    guardar({ club_version_legal: version });
  };

  const seVe = (bloque) => {
    if (bloque.checkVisibility && !bloque.checkVisibility({ visibilityProperty: true, opacityProperty: true })) return false;
    if (!bloque.checkVisibility && bloque.offsetParent === null) return false;
    const caja = bloque.getBoundingClientRect();
    return caja.width > 0 && caja.height > 0 && caja.bottom > 0 && caja.top < window.innerHeight;
  };

  const revisar = () => {
    document.querySelectorAll('[data-jb-club][data-version]').forEach((bloque) => {
      if (seVe(bloque)) anotarVersion(bloque);
    });
  };

  const vigilar = () => {
    const bloques = document.querySelectorAll('[data-jb-club][data-version]');
    if (!bloques.length) return;
    if ('IntersectionObserver' in window) {
      const observador = new IntersectionObserver((entradas) => {
        if (entradas.some((entrada) => entrada.isIntersecting)) revisar();
      });
      bloques.forEach((bloque) => observador.observe(bloque));
    }
    const cambios = new MutationObserver(() => {
      revisar();
      setTimeout(revisar, 500);
    });
    document.querySelectorAll('.cart-notification, cart-drawer, .drawer').forEach((contenedor) =>
      cambios.observe(contenedor, { attributes: true, attributeFilter: ['class', 'style'] })
    );
    revisar();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vigilar);
  else vigilar();
})();
